
import { Component, Vue } from "vue-property-decorator";

@Component
export class ConfirmClosePopup extends Vue {

  show = false

  showPopup () {
    this.show = true
  }

  onCancel () {
    this.show = false
    this.$emit('cancel')
  }

  onConfirm () {
    this.show = false
    this.$emit('confirm')
  }
}
export default ConfirmClosePopup
